import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface ErrorNotificationProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const useStyles = makeStyles({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 999999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  container: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: tokens.shadow16,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    padding: tokens.spacingVerticalXXXL,
    maxWidth: "500px",
    width: "90%"
  },
  content: {
    display: "flex",
    gap: tokens.spacingHorizontalL,
    alignItems: "flex-start"
  },
  icon: {
    fontSize: "32px",
    flexShrink: 0
  },
  text: {
    flex: 1
  },
  title: {
    margin: `0 0 ${tokens.spacingVerticalS} 0`,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorPaletteRedForeground1
  },
  message: {
    margin: 0,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    lineHeight: tokens.lineHeightBase300
  },
  actions: {
    display: "flex",
    gap: tokens.spacingHorizontalM,
    justifyContent: "flex-end",
    marginTop: tokens.spacingVerticalXL
  }
});

export const ErrorNotification = ({
  isOpen,
  title,
  message,
  onClose
}: ErrorNotificationProps) => {
  const { t } = useTranslation("requestsPage");
  const styles = useStyles();

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.icon}>❌</div>
          <div className={styles.text}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.message}>{message}</p>
          </div>
        </div>
        <div className={styles.actions}>
          <Button
            appearance="primary"
            onClick={onClose}
            style={{ minWidth: "100px" }}
          >
            {t("modal.buttons.close")}
          </Button>
        </div>
      </div>
    </div>
  );
};
